import {
  Actor,
  CollisionType,
  Color,
  DefaultLoader,
  Engine,
  ExcaliburGraphicsContext,
  Scene,
  SceneActivationContext,
  Timer,
  vec,
} from "excalibur";
import { Herby } from "./herby";
import { Plant, randomPlantType } from "./plant";
import { Constants } from "./const";
import { JunkFood, randomJunkFoodType } from "./junk";
import { PlantCollection } from "./collection";
import { showPost } from "./main";

export class MyLevel extends Scene {
  override onInitialize(engine: Engine): void {
    // Add ground collider
    const ground = new Actor({
      name: "Ground",
      pos: vec(Constants.GameWidth / 2, Constants.GroundY + 50),
      width: Constants.GameWidth,
      height: 100,
      collisionType: CollisionType.Fixed, // Fixed means it doesn't move
      color: Color.Transparent,
    });
    this.add(ground);

    const collection = new PlantCollection();
    this.add(collection);
    // Scene.onInitialize is where we recommend you perform the composition for your game
    const herby = new Herby();

    // Get translated messages from data attributes
    const postGameEl = document.getElementById("post-game")!;
    const winTitle = postGameEl.dataset.winTitle || "You Win!";
    const winMessage =
      postGameEl.dataset.winMessage ||
      "Congratulations! Herby has collected all 30 plants and is feeling great!";
    const loseTitle = postGameEl.dataset.loseTitle || "Game Over";
    const loseMessage =
      postGameEl.dataset.loseMessage ||
      "Oh no! Herby ate junk food and is feeling rather ill.";

    herby.events.on("herbydied", (evt) => {
      showPost(loseTitle, loseMessage);
      this.engine.stop();
    });
    herby.events.on("herbyate", (evt) => {
      collection.addPlant(evt.food.Type);
      if (collection.Size >= 30) {
        showPost(winTitle, winMessage);
        this.engine.stop();
      }
    });
    this.add(herby); // Actors need to be added to a scene to be drawn
    const timer = new Timer({
      interval: 1000,
      repeats: true,
      action: () => this.spawnFood(),
    });
    this.add(timer);
    timer.start();
  }

  protected spawnFood() {
    const isJunk = Math.random() < Constants.JunkProbability;
    const food = isJunk
      ? new JunkFood(randomJunkFoodType())
      : new Plant(randomPlantType());
    const isHigh = Math.random() < 0.5;
    food.pos = isHigh ? food.pos.add(vec(0, -200)) : food.pos;
    this.add(food);
  }

  override onPreLoad(loader: DefaultLoader): void {
    // Add any scene specific resources to load
  }

  override onActivate(context: SceneActivationContext<unknown>): void {
    // Called when Excalibur transitions to this scene
    // Only 1 scene is active at a time
  }

  override onDeactivate(context: SceneActivationContext): void {
    // Called when Excalibur transitions away from this scene
    // Only 1 scene is active at a time
  }

  override onPreUpdate(engine: Engine, elapsedMs: number): void {
    // Called before anything updates in the scene
  }

  override onPostUpdate(engine: Engine, elapsedMs: number): void {
    // Called after everything updates in the scene
  }

  override onPreDraw(ctx: ExcaliburGraphicsContext, elapsedMs: number): void {
    // Called before Excalibur draws to the screen
  }

  override onPostDraw(ctx: ExcaliburGraphicsContext, elapsedMs: number): void {
    // Called after Excalibur draws to the screen
  }
}
